import React from "react";

const Info = () => {
  return (
    <div className="about__info grid">
      <div className="about__box">
        <i class="bx bx-award about__icon"></i>

        <h3 className="about__title">Erfahrung</h3>
        <span className="about__subtitle">3 + Jahre</span>
      </div>

      <div className="about__box">
        <i class="bx bx-briefcase-alt about__icon"></i>

        <h3 className="about__title">Umgesetzt</h3>
        <span className="about__subtitle">20 + Projekte</span>
      </div>

      <div className="about__box">
        <i class="bx bx-support about__icon"></i>

        <h3 className="about__title">Kunden</h3>
        <span className="about__subtitle">10 + Kunden</span>
      </div>
    </div>
  );
};

export default Info;
